import { Container, Typography } from '@cleartrip/ct-design-components'
import { useEffect, useState } from 'react'
import InputRange from 'react-input-range-rtl'
import FilterJourneyInfo from './FilterJourneyInfo'
import RangeSlider from './RangeSlider'

const DurationFilter = (props: any) => {
  const {
    currentDuration,
    minInHours,
    maxInHours,
    onFilterChange,
    filterType,
    label,
    from,
    to,
    isRT,
    isRevamp = false,
  } = props

  const [duration, setDuration] = useState(maxInHours)

  const onDurationValueChange = (durationValue: any) => {
    setDuration(durationValue)
  }
  useEffect(() => {
    setDuration(currentDuration.max)
  }, [currentDuration])

  const onDurationValueChangeComplete = () => {
    onFilterChange(filterType, duration)
  }

  const minLabel = minInHours
  const maxLabel = duration
  // Revamp copy per Figma: "Travel time: Upto 23 hrs"
  const labelText = isRevamp ? 'Travel time' : label
  const boundWord = isRevamp ? 'Upto' : 'Under'
  const valueText = label === 'Travel Time' ? `${boundWord} ${maxLabel} hrs` : `${minLabel} - ${maxLabel} hrs`

  return (
    <>
      <FilterJourneyInfo from={from} to={to} isRT={isRT} isRevamp={isRevamp} legacyClassName='c-pointer my-3' />
      <Container className='flex flex-middle'>
        <Typography
          variant='P2'
          color='subheading'
          className={isRevamp ? 'pb-2 mr-1' : 'pb-4 mr-1'}
        >{`${labelText}:`}</Typography>
        <Typography variant='P2' className={isRevamp ? 'pb-2' : 'pb-4 '}>
          {valueText}
        </Typography>
      </Container>
      {isRevamp ? (
        <RangeSlider
          ariaLabel={label}
          max={maxInHours}
          min={minInHours}
          value={duration}
          onChange={setDuration}
          onChangeComplete={value => onFilterChange(filterType, value)}
        />
      ) : (
        <div className='pl-1 pb-6 intl_inputRange' style={{ width: '90%' }}>
          <InputRange
            minValue={minInHours}
            maxValue={maxInHours}
            value={duration}
            onChange={onDurationValueChange}
            onChangeComplete={onDurationValueChangeComplete}
            step={1}
          />
        </div>
      )}
    </>
  )
}

export default DurationFilter
